module.exports = __webpack_public_path__ + "out-of-stock.png?c283b83bcec97b1fec005e9c203d7fe6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/out-of-stock.png
// module id = 991
// module chunks = 2